{
	"allImages": "All images in project ({{totalCount}})",
	"ariaAllPhotos": "All Photos",
	"ariaSelectedPhotos": "Selected Photos",
	"selectedImages": "Selected images ({{count}})",
	"selectedImagesExportable": "Selected images ({{exportableCount}}/{{count}} exportable)",
	"stillProcessing": " - Some photos are still processing"
}
